<template>
  <div id="left-side"
       :class="[locationClassName]">
    <!-- <div class="second-nav">
      <div v-for="(item,index) in items"
           :key='item'
           @click='tabclick(index)'
           class="second-tab"
           :class='{active:index==selectStatus}'>{{item}}</div>
      <span class="filter-icon"
            v-bind:class="[{open:showSelectList},{iconactive:isNotDefault}]"
            @click="toggleSelectList"></span>
    </div> -->
    <ul class="select-list"
        v-show="showSelectList">
      <li class="tab-item">
        <span class="tab-nav tab-map"
              @click='tabclick(1)'
              v-show="selectStatus==0"
              :class="{'tab-active':selectStatus==0}">

        </span>
        <span class="tab-nav tab-list"
              @click='tabclick(0)'
              v-show="selectStatus==1"
              :class="{'tab-active':selectStatus==1}">
        </span>
      </li>

      <li class="select-item"
          @click.stop="changeDropDown(0)">
        <span class="select-checkbox"
              v-bind:class="{checked:checkboxMark.industry}"></span> 行业
      </li>
      <li class="select-item"
          @click.stop="changeDropDown(1)">
        <span class="select-checkbox"
              v-bind:class="{checked:checkboxMark.concept}"></span> 概念
      </li>
      <!-- <li class="drop-down"
          @click.stop="showDropDown">
        <span>{{dropDown.dropDownList[dropDown.activeIndex]}}&nbsp;&nbsp;</span>
        <span v-if="dropDown.show"
              class="arrow-up"> </span>
        <span v-else
              class="arrow-down"> </span>
        <ul id="drop-down-content"
            v-if="dropDown.show">
          <li v-for="(item,index) in dropDown.dropDownList"
              :key="index"
              @click.stop="changeDropDown(index)">
            {{item}}
          </li>
        </ul>
      </li> -->
      <li class="hotTop10"
          :class="{active:top10State}"
          @click="changeDropDown(3)"
          v-show="selectStatus==1">
        近期热门TOP10
      </li>
      <!-- <li class="select-item"
          v-if="showConcern"
          @click="toggleSelectItem('concern')">
        <span class="select-checkbox"
              v-bind:class="{checked:checkboxMark.concern}"></span> 关注
      </li> -->
      <li class="select-icon"
          @click="openSelection"
          v-if="showConcern">

      </li>
    </ul>
    <div class=" tip-alert"
         id="mapAlertTip">

    </div>
    <!-- <router-view></router-view> -->
    <block-map v-show="show"></block-map>
    <block-list v-show="!show"
                :top10State='top10State'></block-list>
    <div id="list2">
      <div class="recommend-head"
           v-if="location===2">
        <div v-for="(item,index) in tabName"
             :key="index"
             :class="{active:index===list2TabIndex}"
             class="list2-tab"
             @click="setList2TabIndex(index)">{{item}}
        </div>
      </div>
      <block-list2 v-show="location!==2||list2TabIndex===1"></block-list2>
      <hot-recommend v-show="location===2&&list2TabIndex===0"></hot-recommend>
    </div>
  </div>
</template>
<script>
// import  blockmap from '@/components/blockmaps/blockmap.vue'
import router from '@/router/index.js';
import blockList2 from '@/components/blockmaps/blockList2.vue';
import hotRecommend from '@/components/blockmaps/hotRecommend.vue';
import blockmap from '@/components/blockmaps/blockmap.vue';
import blockList from '@/components/blockmaps/blockList.vue';
import { mapState,mapMutations } from 'vuex';

export default {
  name: 'leftSide',
  components: {
    'block-list2': blockList2,
    'block-map': blockmap,
    'block-list': blockList,
    'hot-recommend': hotRecommend
  },
  computed: {
    ...mapState(['top10State']),
    locationClassName() {
      const className = ['', '', 'hotanalysis-list'];
      return className[this.location];
    }
  },
  created() {
    eventBus.$on('ListStatus', this.handle);
    eventBus.$on('openSelect', this.openSelection);
    // eventBus.$on('toggleSelectItem', this.checkConcern);
    eventBus.$on('modifyConcern', this.checkConcern);
    eventBus.$on('tab', this.locationHandle);
  },
  beforeDestroy() {
    eventBus.$off('openSelect', this.openSelection);
    eventBus.$off('ListStatus', this.handle);
    // eventBus.$off('toggleSelectItem', this.checkConcern);
    eventBus.$off('tab', this.locationHandle);
    eventBus.$off('modifyConcern', this.checkConcern);
  },
  mounted() {
    var self = this;
    // const cookiestr =
    //   'searchGuide=sg; Hm_lvt_78c58f01938e4d85eaf619eae71b4ed1=1530067312; user=MDp0ZXN0anJkczM6Ok5vbmU6NTAwOjM5MzIzMjQ1MTo0LDEwMDAwMDAwMTAwMTAwMDAwMDExMTExMSwyMjU7NSwxLDQwOzYsMSw0MDs3LDExMTExMTExMTExMCw0MDsyMCwxLDIyNTsyMiwxLDIyNTsyNiwxLDIyNTsyNywxLDIyNTsyOSwxLDIyNTszMywwMDExMDAwMDAwMTEsMjI1OzM2LDEwMDExMTExMTAwMDExMTExMDExMTExMSwyMjU7NDEsMTExMTEsMjI1OzQyLDEwMDEwMSwyMjU7NDMsMTAxMTExMTExMTExMTExMTExMTExMTExLDIyNTs0NCwxMTExMSw0MDs0NSwxMDExMTExMTEsMjI1OzQ2LDAxMTAxMTExMTAwMDAwMTExMTExMTExMSwyMjU7NDcsMTExMTExMTExMTExMTExLDIyNTs0OCwxMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMSwyMjU7NTAsMTEsMjI1OzUxLDExMDAwMDAwMDAwMDAwMDAsMjI1OzUyLDEwMDAsMjI1OzU0LDEwMDAwMDAwMDAwMDAwMDAwMDAwMDAxMDAwMDAwMCwyMjU7NTYsMTEsMjI1OzU3LDExMTExMTExMTExMTExMDAwMDAxLDIyNTs1OCwxMTExMTExMTExMTExMTExMSwyMjU7NjAsMTExMTExMTExMTExMTExMTEsMjI1OzYxLDExLDIyNTs2MiwxMTAwMDAwMDAwMDAwMDAwMTAwMDAwMDAsMjI1OzYzLDEwMDEwMDAxMDAwMDAwMDAwMDAwMDAwMCwyMjU7NjQsMDAwMTExMTAwMTAwMDAwMDAwMDEwMDAwLDIyNTs2NiwxMTExMTExMTExMTExLDIyNTs2OCwxMTExMTExMTEwMTExMTExMSwyMjU7NzMsMTExMSwyMjU7NzcsMTAwMDAxLDIyNTs3OCwxLDIyNTs5MSwxMTExMSwyMjU7OTIsMTAwLDIyNTsxLDEsNDA7MiwxLDQwOzMsMSw0MDs4LDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAxLDQwOjg6OjozODMyMzI0NTE6MTUzMzEwMzM5NTo6OjE0ODkwMzgxODA6NDAzMDA1OjA6MTA4YjZjZDZlNmNkMWE4YzA5NjJkNzVhY2FhYjU1ZDNlOjow; userid=383232451; u_name=testjrds3; escapename=testjrds3; ticket=c2ca6749adab74dbdec4a72fd37f0cbb; @#!userid!#@=383232451; @#!sessionid!#@=108b6cd6e6cd1a8c0962d75acaab55d3e; @#!rsa_version!#@=default_2; v=AuiUlb6rJ-qTwAtuH4SnW_-Wud35EUwbLnUgn6IZNGNW_YLBSiEcq36F8C3x';
    // const cookieArr = cookiestr.split('; ');
    // for (let value of cookieArr) {
    //   document.cookie = value;
    // }

    self.checkConcern();
    $(window).resize(() => {
      //当浏览器大小变化时
      this.locationHandle(this.location);
      this.tabclick(this.selectStatus);
      this.resizeLestSide();
    });
    this.resizeLestSide();
    document.addEventListener('click', () => {
      this.dropDown.show = false;
    });
  },
  data() {
    return {
      items: ['板块地图', '板块列表'],
      dropDown: {
        show: false,
        dropDownList: ['行业', '概念', '全部'],
        activeIndex: 2
      },
      selectStatus: 0,
      show: true,
      showConcern: window.clientType == 2,
      checkboxMark: {
        industry: true,
        concept: true,
        zone: false,
        concern: false
      },
      hasConcern: false,
      timersTimeout: false,
      markLength: 0,
      url: `//apigate.${window.Acme.getDomain()}/d/charge`,
      showSelectList: true,
      mapSelect: '',
      isNotDefault: false, //默认筛选按钮样式
      listSelect: '',
      location: 0,
      tabName: ['热点推荐', '个股列表'],
      list2TabIndex: 0,
      newitems: [{}]
    };
  },
  methods: {
    ...mapMutations(['setCheckboxMark']),
    //设置行业概念勾选的参数
    setCheck(){
      if(this.checkboxMark.industry&&this.checkboxMark.concept){
        this.setCheckboxMark('no_filter');
      }else if(this.checkboxMark.industry){
        this.setCheckboxMark('industry');
      }else if(this.checkboxMark.concept){
        this.setCheckboxMark('concept');
      }else{}
    },
    resizeLestSide() {
      if (document.body.clientHeight > 843) {
        var height = document.body.clientHeight - 50 + 'px';
        $('#left-side').css('height', height);
      } else {
        $('#left-side').css('height', '855px');
      }
    },
    locationHandle(val) {
      this.location = val;
      //location为2表示在热点剖析页面
      // if (val == 2) {
      //   $('#listContainer2')
      //     .getNiceScroll()
      //     .resize();
      // }
    },
    showDropDown() {
      this.dropDown.show = this.dropDown.show ? false : true;
    },
    changeDropDown(index) {
      if (index == 0) {
        // this.checkboxMark.industry = true;
        // this.checkboxMark.concept = false;
        if (this.checkboxMark.concept) {
          this.checkboxMark.industry = !this.checkboxMark.industry;
        } else {
          return;
        }

        TA.log({ id: 'jrds_hottrack_wdh_20180815_8' });
      } else if (index == 1) {
        // this.checkboxMark.industry = false;
        // this.checkboxMark.concept = true;
        if (this.checkboxMark.industry) {
          this.checkboxMark.concept = !this.checkboxMark.concept;
        } else {
          return;
        }
        TA.log({ id: 'jrds_hottrack_wdh_20180815_9' });
      } else if (index == 2) {
        this.checkboxMark.industry = true;
        this.checkboxMark.concept = true;
        TA.log({ id: 'jrds_hottrack_wdh_20180815_10' });
      } else if (index == 3) {
        //近期热门
        this.checkboxMark.concern = false;
        this.$store.commit('setTop10State', !this.top10State);
        if (this.top10State) {
          this.show = false;
          this.selectStatus = 1;
        }
        this.tabclick(1);
        TA.log({ id: 'jrds_hottrack_wdh_20180815_11' });
        // return false;
      }
      this.dropDown.show = false;
      if (index !== 3) {
        this.dropDown.activeIndex = index;
      }
      this.setCheck();
      this.setSelected();
    },
    getChooseStatus() {
      const self = this;
      $.ajax({
        url: self.url + '/hottrack/plate/getchoosestatus',
        headers: {
          cookie: document.cookie
        },
        data: {
          'client-type': window.clientType
        },
        dataType: 'jsonp',
        jsonp: 'callback',
        success: function(data) {
          if (data.result.length == 0) {
            // 都没有选中
            $.each(self.checkboxMark, function(key, val) {
              self.checkboxMark[key] = true;
            });
          } else {
            $.each(data.result, function(key, val) {
              self.checkboxMark[val.name] = val.concern;
              if (val.concern) {
                self.markLength++;
              }
            });
            if (window.clientType != 2 && self.checkboxMark['concern']) {
              self.markLength = 4;
              self.checkboxMark = {
                industry: true,
                concept: true,
                zone: false,
                concern: true
              };
              self.toggleSelectItem('concern');
            }
            //lxc add 20180801 start
            // if (window.clientType == 2) {
            if (self.checkboxMark.industry && self.checkboxMark.concept) {
              self.dropDown.activeIndex = 2;
            } else if (self.checkboxMark.industry) {
              self.dropDown.activeIndex = 0;
            } else if (self.checkboxMark.concept) {
              self.dropDown.activeIndex = 1;
            } else {
              self.checkboxMark.industry = true;
              self.checkboxMark.concept = true;
              self.dropDown.activeIndex = 2;
            }
            self.checkboxMark.zone = false;
            // }
            self.setCheck();
            // 获取完用户左上角选择的模块后，分发给其他组件
            window.eventBus.$emit('toggleSelectItem', self.checkboxMark);
            self.checkDefaultIcon();
          }
        }
      });
    },
    checkDefaultIcon() {
      const self = this;

      //判断筛选图标是否变蓝
      if (
        self.checkboxMark['industry'] &&
        self.checkboxMark['concept'] &&
        self.checkboxMark['zone'] &&
        !self.checkboxMark['concern']
      ) {
        //默认样式
        self.isNotDefault = false;
      } else {
        self.isNotDefault = true;
      }
    },
    handle(val) {
      this.listSelect = val;
    },
    openSelection() {
      eventBus.$emit('openSeletion', true);
    },
    setSelected() {
      const self = this;
      let markCount = 0;
      let markLength = 0;
      $.each(this.checkboxMark, function(key, val) {
        if (val) {
          switch (key) {
            case 'industry':
              markCount += 1;
              break;
            case 'concept':
              markCount += 2;
              break;
            case 'zone':
              markCount += 4;
              break;
            case 'concern':
              // markCount += 8;
              markCount += 0;
              break;
          }
          markLength++;
        }
      });
      self.markLength = markLength;
      $.ajax({
        url: self.url + '/hottrack/plate/addchoosestatus',
        data: {
          status: markCount,
          'client-type': window.clientType
        },
        xhrFields: {
          withCredentials: true
        },
        dataType: 'jsonp',
        success: function(data) {
          $('#listContainer').scrollTop(0);
          if (data.errorcode == 0) {
            console.log('改变' + markCount);
            eventBus.$emit('toggleSelectItem', self.checkboxMark);
          } else {
            // self.checkboxMark[name] = !self.checkboxMark[name];
            self.checkboxMark['concern'] = false;
            self.setSelected();
            $('#mapAlertTip').html(data.errormsg);
            self.timersTimeout = true;
            $('#mapAlertTip').fadeIn(function() {
              setTimeout(function() {
                self.timersTimeout = false;
                $('#mapAlertTip').fadeOut();
              }, 1600);
            });

            self.markLength++;
          }
          self.checkDefaultIcon();
        },
        error: function(e) {
          console.log(e);
        }
      });
    },
    toggleSelectItem(name) {
      if (name === 'concern') {
        this.$store.commit('setTop10State', false);
      }
      const self = this;
      console.log(self.checkboxMark);
      if ((self.checkboxMark[name] && self.markLength == 1) || self.timersTimeout) {
        return;
      }
      this.checkboxMark[name] = !this.checkboxMark[name];
      this.setSelected();
    },
    checkConcern(concernblock) {
      const self = this;
      if (concernblock) {
        const concerns = [];
        let hasIndustry = false;
        let hasConcept = false;
        for (let value of concernblock) {
          if (value.block_code.substring(0, 3) === '881') {
            hasIndustry = true;
          } else if (value.block_code.substring(0, 3) === '885') {
            hasConcept = true;
          }
        }
        if ((!hasIndustry && this.dropDown.activeIndex === 0) || (!hasConcept && this.dropDown.activeIndex === 1)) {
          this.checkboxMark.concern = false;
          this.setSelected();
          // let message = this.dropDown.activeIndex === 0 ? '用户无关注行业板块' : '用户无关注概念板块';
          // $('#mapAlertTip').html(message);
          // self.timersTimeout = true;
          // $('#mapAlertTip').fadeIn(function() {
          //   setTimeout(function() {
          //     self.timersTimeout = false;
          //     $('#mapAlertTip').fadeOut();
          //   }, 1600);
          // });
          return;
        }
        eventBus.$emit('toggleSelectItem', 1);
        return;
      }

      //判断是否有关注股
      // const self = this;
      self.getChooseStatus();
      return;
      // $.ajax({
      //   url: self.url + "/hottrack/plate/concernblacklist",
      //   headers: {
      //     cookie: document.cookie
      //   },
      //   data: {
      //     "client-type": window.clientType
      //   },
      //   dataType: "jsonp",
      //   success: function(data) {
      //     if (data.errorcode == 0) {
      //       if (data.result.follow.length) {
      //         self.hasConcern = true;
      //       } else {
      //         self.hasConcern = false;
      //         self.checkboxMark.concern = false;
      //       }
      //     }
      //   }
      // });
    },
    toggleSelectList() {
      this.showSelectList = !this.showSelectList;
      // if (this.showSelectList) {
      //   // $('#list2').css('top', parseInt($('#list2').css('top')) + 28);
      //   // $('#listContainer2').css('height', parseInt($('#listContainer2').css('height')) - 58);
      // } else {
      //   // $('#listContainer2').css('height', parseInt($('#listContainer2').css('height')) + 58);
      //   // $('#list2').css('top', parseInt($('#list2').css('top')) - 28);
      // }
      // // $('#listContainer2')
      // //   .getNiceScroll()
      // //   .resize();
      // this.$nextTick(() => {
      //   $('#listContainer')
      //     .getNiceScroll()
      //     .resize();
      // });
      // setTimeout(function() {

      // }, 50);
    },

    tabclick(index) {
      //板块地图和板块列表的点击
      var self = this;
      // if (index == self.selectStatus) {
      //   return;
      // }
      self.selectStatus = index;
      eventBus.$emit('selectStatus', index);
      if (index == 0) {
        self.show = true;
        eventBus.$emit('tomap', self.listSelect);
        this.$store.commit('setTop10State', false);
        TA.log({ id: 'L2rdzz_5a77eef2_379' });
        if (self.location == 2) {
          // $('#listContainer').css('height', 455);
          // $('#listContainer').css('height', 242);
          // $('#list2').css('top', 578);
          // $('#hot-recommend-container').css('height', $('#app').height() - 655);
          // this.setListHeight();
        }
      }
      if (index == 1) {
        TA.log({ id: 'L2rdzz_5a77ef3a_447' });
        self.show = false;
        if (self.location == 2) {
          // if (this.showSelectList) {
          //   $('#listContainer').css('height', 332);
          // } else {
          //   $('#listContainer').css('height', 360);
          // }
          // $('#list2').css('top', 450);
          // $('#hot-recommend-container').css('height', $('#app').height() - 525);
          // $('#listContainer2').css('height', $('#app').height() - 555);
        } else {
          // $('#listContainer').css('height', 455);
          // if (this.showSelectList) {
          //   $('#list2').css('top', 578);
          // } else {
          //   $('#list2').css('top', 550);
          // }
          // $('#hot-recommend-container').css('height', $('#app').height() - 655);
        }
      }
    },
    setList2TabIndex(index) {
      //热点推荐和个股列表的切换
      this.list2TabIndex = index;
      if (index === 1) {
        // this.setListHeight();
        this.$nextTick(() => {
          $('#listContainer2')
            .getNiceScroll()
            .resize();
        });
        // setTimeout(function() {

        // }, 50);
      }
      TA.log({ id: 'jrds_hottrack_wdh_20180815_7' });
    }
  }
};
</script>
<style>
#left-side {
  clear: both;
  width: 305px;
  min-height: 806px;
  height: 100%;
  margin-top: 1px;
  float: left;
  background: #1b1b1b;
  position: relative;
  display: flex;
  flex-direction: column;
}

.white #left-side {
  background-color: #4a4a4a;
}
.recommend-head {
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  /* text-align: left; */
  background-color: #2a2a2a;
  /* padding-left: 10px; */
  color: #a0a0a0;
  display: flex;
  justify-content: space-around;
  border-bottom: 1px solid #1b1b1b;
  flex-shrink: 0;
}
.second-nav {
  height: 28px;
  background-color: #292929;
  color: #7d7d7d;
  margin-left: 1px;
  font-size: 14px;
  position: relative;
}
.white .second-nav {
  background-color: #424242;
}
.second-nav .active {
  color: white;
}
.second-tab {
  height: 28px;
  line-height: 28px;
  float: left;
  width: calc(50% - 13px);
}

.tip-alert {
  position: absolute;
  display: none;
  font-size: 12px;
  width: 160px;
  top: 60px;
  background: #fff;
  padding: 5px 9px;
  border-radius: 6px;
  cursor: default;
  left: 50%;
  margin-left: -80px;
  border: 1px solid red;
  color: rgb(218, 47, 47);
  z-index: 20;
}
.filter-icon {
  background: url(../../assets/select2.png) no-repeat;
  width: 21px;
  height: 12px;
  display: inline-block;
  margin-top: 9px;
  margin-right: 5px;
  cursor: pointer;
}
.filter-icon.open {
  background-position-y: -15px;
}
.filter-icon.iconactive {
  background-position-x: -26px;
}
.second-tab:hover {
  cursor: pointer;
}
.select-list {
  margin: 0;
  padding: 0;
  margin-top: 1px;
  background: #292929;
  list-style: none;
  width: 100%;
  height: 27px;
  position: relative;
}
.white .select-list {
  background-color: #434343;
}
.select-list li {
  float: left;
  margin-left: 13px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
  color:#a0a0a0;
}
.select-list .drop-down {
  border: 1px solid #757575;
  height: 18px;
  line-height: 18px;
  margin-top: 5px;
  background-color: #292929;
  color: white;
  width: 45px;
  border-radius: 3px;
  position: relative;
}
.white .select-list .drop-down {
  background-color: #434343;
}
.select-list .hotTop10 {
  margin-top: 5px;
  line-height: 16px;
  border: 1px solid #757575;
  width: 94px;
  height: 18px;
  border-radius: 2px 2px 2px 2px;
  color: #9b9b9b;
}
.select-list .active {
  background-color: #d6524d;
  color: white;
  border: 1px solid #d6524d;
}
#drop-down-content {
  position: absolute;
  left: 0px;
  top: 20px;
  border: 1px solid #7d7d7d;
  z-index: 9;
  padding-left: 0;
}
#drop-down-content li {
  margin: 0;
  display: block;
  float: none;
  height: 20px;
  width: 43px;
  background-color: #474747;
  line-height: 20px;
  color: #bcbcbc;
  opacity: 0.9;
}
#drop-down-content li:hover {
  color: #fff;
}

.arrow-down {
  display: inline-block;
  height: 0px;
  width: 0px;
  border-width: 4px;
  border-style: solid;
  border-color: white transparent transparent;
  line-height: 30px;
  position: absolute;
  top: 7px;
  left: 35px;
}
.arrow-up {
  display: inline-block;
  height: 0px;
  width: 0px;
  border-width: 4px;
  border-style: solid;
  border-color: transparent transparent white;
  position: absolute;
  top: 3px;
  left: 35px;
}
.select-list .checked::after {
  content: '\2714';
  position: absolute;
  top: -10px;
  left: 1px;
}
.select-checkbox {
  width: 12px;
  height: 12px;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  position: relative;
  border: 1px solid #7d7d7d;
  margin: 0 3px 0 0;
}
.select-list .select-icon {
  display: inline-block;
  background-image: url(../../assets/select.svg);
  width: 16px;
  height: 16px;
  float: right;
  margin-top: 7px;
  margin-right: 10px;
}

#list2 {
  /* position: absolute; */
  /* top: 578px; */
  /* bottom: 0; */
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  min-height: 0;
  flex: 1;
}
.active {
  color: white;
}
.list2-tab {
  cursor: pointer;
  flex-grow: 1;
}

.tab-item {
  display: flex;
  align-items: center;
  height: 27px;
}

.tab-nav {
  display: inline-block;
  height: 14px;
  width: 14px;
}


.tab-map {
  background: url('//i.thsi.cn/images/level2/hottrack/20190227/icon_map.png') no-repeat;
}

.tab-map.tab-active {
  background: url('//i.thsi.cn/images/level2/hottrack/20190410/sprite.png') -277px -0px no-repeat;
}

.tab-list {
  background: url('//i.thsi.cn/images/level2/hottrack/20190410/sprite.png') -291px -0px no-repeat;
}

.tab-list.tab-active {
  background: url('//i.thsi.cn/images/level2/hottrack/20190227/icon_list_active1.png') no-repeat;
}

.select-item {
  display: flex;
  align-items: center;
}
</style>




// WEBPACK FOOTER //
// src/pages/common/leftSide.vue